import React, { Component } from 'react';
import './style/wallet.css';
import './style/normalize.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { 
        Redirect,
        Link
       } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Menu from './Components/Menu';
import Cards from 'react-credit-cards';
import NumberFormat from 'react-number-format';
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatFormData,
  } from './Components/utils';
import Loading from './Components/Loading/Loading';
import moment from 'moment';
import walletEmpy from './images/vazio.png'
import { transactionID } from "./services/helpers";



class Wallet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            currBalance: "",
            phone: '',
            cardList: [],
            financial: [],
            cardSelected: {
                index: "n",
                digFour: "0000",
                flag: ""
            },
            total: 0,
            myWallet: true,
            addCardForm: false,
            focused: '',
            cardData: {
                type: '',
                name: '',
                number: '',
                expiry: '',
                cvv: '',
                cpf: ''
            },
            loading: 0
        }
    };

    AccountDetails = () => {

        if(JSON.parse(localStorage.getItem("clientInfo")) === null) {
            return false;
        }


        axios.post(`https://www.pagtel.com.br/Hub360Correios/v2/AccountDetails`, {
            transactionID: transactionID('AAD'),
            MSISDN: JSON.parse(localStorage.getItem("clientInfo")).number,
        }, { headers: {"Authorization": "Bearer " + JSON.parse(localStorage.getItem("clientInfo")).accessToken } })
        .then(res => {
            switch(res.data.code){

                case 'P00':

                    // console.log(res.data);
                    let accountDetails = {
                        msisdn: res.data.msisdn,
                        networkID: res.data.networkID,
                        validityDate: res.data.validityDate,
                        currBalance: res.data.currBalance.replace('.', ''),
                        languageID: res.data.languageID,
                        planID: res.data.planID,
                        simStatus: res.data.simStatus,
                    }

                    localStorage.setItem('accountDetails', JSON.stringify(accountDetails));
                    
                    this.setState({currBalance: res.data.currBalance.replace('.', ''), phone: res.data.msisdn});
                    
                    
                    //localStorage.setItem('numberInfo', JSON.stringify(testObject));

                    break;
                default:
                    Swal.fire({
                        title: 'Erro!',
                        text: res.data.msg,
                        type: 'error'
                    }); 
                    break;

            }
         
        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao conectar com o servidor",
                type: 'error'
            });
            this.setState({redirect: true});
        })
    }

    GetCard = () => {

        if(JSON.parse(localStorage.getItem("clientInfo")) === null) {
            return false;
        }


        axios.post(`https://www.pagtel.com.br/Hub360Correios/v2/GetCard`, {
            transactionID: transactionID('AAE'),
            MSISDN: JSON.parse(localStorage.getItem("clientInfo")).number,
        }, { headers: {"Authorization": "Bearer " + JSON.parse(localStorage.getItem("clientInfo")).accessToken } })
        .then(res => {
            switch(res.data.code){

                case 'P00':
                    this.setState({
                        cardList: res.data.cardList
                    })

                    break;
                default:
                    this.setState({
                        cardList: []
                    })

                    break;

            }
         
        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao conectar com o servidor",
                type: 'error'
            });
            this.setState({redirect: true});
        })
    }

    financialHistory = (digFour) => {

        if(JSON.parse(localStorage.getItem("clientInfo")) === null) {
            return false;
        }

        var d = new Date();
        d.setMonth(d.getMonth() + 1);

        axios.post(`https://www.pagtel.com.br/Hub360Correios/v2/financialHistory`, {
            transactionID: transactionID('AAF'),
            MSISDN: JSON.parse(localStorage.getItem("clientInfo")).number,
            year: d.getFullYear(),
            month: d.getMonth()
        }, { headers: {"Authorization": "Bearer " + JSON.parse(localStorage.getItem("clientInfo")).accessToken } })
        .then(res => {
            switch(res.data.code){

                case 'P00':

                    let total = 0, newFinancial =  res.data.financial.filter(function(hero) {
                    // console.log(hero.paymentID , digFour);
                        if((hero.digFour === digFour)&&(hero.transStatus === "P00")){
                            total += parseFloat(hero.amount);
                        }
                        return ((hero.digFour === digFour)&&(hero.transStatus === "P00"));
                    });

                    this.setState({
                        financial: newFinancial,
                        total: this.formatMoney(total)
                    })

                    break;
                case 'P01':
                    // let total = 0, newFinancial =  res.data.financial.filter(function(hero) {
                    // // console.log(hero.paymentID , digFour);
                    //     if((hero.digFour === digFour)&&(hero.transStatus === "P00")){
                    //         total += parseFloat(hero.amount);
                    //     }
                    //     return ((hero.digFour === digFour)&&(hero.transStatus === "P00"));
                    // });
                    this.setState({
                        financial: [],
                        total: this.formatMoney(0)
                    })

                    break;
                default:
                    Swal.fire({
                        title: 'Erro!',
                        text: res.data.msg,
                        type: 'error'
                    }); 
                    break;

            }
         
        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao conectar com o servidor",
                type: 'error'
            });
            this.setState({redirect: true});
        })
    }

    deleteCard = (e) => {
        e.preventDefault();

        if(JSON.parse(localStorage.getItem("clientInfo")) === null) {
            return false;
        }

        let self_ = this;

        axios.post(`https://www.pagtel.com.br/Hub360Correios/v2/deleteCard`, {
            transactionID: transactionID('AAG'),
            MSISDN: JSON.parse(localStorage.getItem("clientInfo")).number,
            paymentID: this.state.cardSelected.paymentID
        }, { headers: {"Authorization": "Bearer " + JSON.parse(localStorage.getItem("clientInfo")).accessToken } })
        .then(res => {
            switch(res.data.code){

                case 'P00':

                    Swal.fire({
                        title: 'Excluído com sucesso!',
                        text: "Cartão excluído com sucesso",
                        type: 'success'
                    });   
                    
                    self_.GetCard();

                    break;
                default:
                    Swal.fire({
                        title: 'Erro!',
                        text: res.data.msg,
                        type: 'error'
                    }); 
                    break;

            }
         
        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao conectar com o servidor",
                type: 'error'
            });
            this.setState({redirect: true});
        })
    }

    addCreditcard = () => {
       
        if(!this.validCard()){
            return false;
        };

        this.setState({loading: 1});

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/addCard', {
        transactionId: transactionID('AAH'),
        msisdn: JSON.parse(localStorage.getItem("clientInfo")).number,
        paymentType: "C",
        cardNumber: this.state.cardData.number,
        expiration: this.state.cardData.expiry,
        cvv: this.state.cardData.cvv,
        cpf: this.state.cardData.cpf,
        name: this.state.cardData.name

        }, { headers: {"Authorization": "Bearer " + JSON.parse(localStorage.getItem("clientInfo")).accessToken } }).then((response) => {

            switch(response.data.code) {
                case 'P00':
                    this.GetCard();
                    this.setState({loading: 0});
                    this.changeWindows();
                    break;

                default:
                    this.setState({loading: 0});
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    })
                    break;
            }
            
        });
    }

    formartDate = (date) => {
        return date.split("-")[2]+"/"+date.split("-")[1]+"/"+date.split("-")[0];
    }

    validCpf = (strCPF) => {
        let Soma;
        let Resto;
        Soma = 0;
      if (strCPF == "00000000000") return false;
         
      for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;
       
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;
       
      Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
       
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
        return true;
    }

    validCard = () => {

        if(this.state.cardData.number === "" || this.state.cardData.number.length < 10 ){
            Swal.fire({
                title: 'Erro!',
                text: "Escolha o cartão!",
                type: 'error'
            });
            return false;
        }

        if(this.state.cardData.name === ""){

            Swal.fire({
                title: 'Erro!',
                text: "Escolha o nome do titular!",
                type: 'error'
            });
            return false;
        }

        if(this.state.cardData.expiry === "" || this.state.cardData.expiry.length < 4){

            Swal.fire({
                title: 'Erro!',
                text: "Escolha a data de vencimento!",
                type: 'error'
            });
            return false;
        }

        if(this.state.cardData.cvv === "" || this.state.cardData.cvv.length === 0){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o CVV!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return false;
        }

        if(!this.validCpf(this.state.cardData.cpf)){
            Swal.fire({
                title: 'Erro!',
                text: "CPF inválido!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return false;
        }

        return true;
    }


    formatReal( int )
    {
        var tmp = int+'';
        tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
        if( tmp.length > 6 )
                tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

        return `R$${tmp}`;
    }

    selectCard = (i) => {
        let cardSelected = [];

        if((i !== "n")&&(this.state.cardList.length !== 0)){
            cardSelected = {
                digFour: this.state.cardList[i].digFour,
                paymentID: this.state.cardList[i].paymentID,
                index: i,
                flag: this.state.cardList[i].flag
            }
        
            this.financialHistory(cardSelected.digFour);

        }
        else {
            cardSelected = {
                index: "n",
                digFour: "0000",
                flag: ""
            }
        }

        this.setState({cardSelected: cardSelected});

    }

    formatMoney = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
        try {
          decimalCount = Math.abs(decimalCount);
          decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
      
          const negativeSign = amount < 0 ? "-" : "";
      
          let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
          let j = (i.length > 3) ? i.length % 3 : 0;
      
          return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
          return "";
        }
    }

    handleInputChange = ({ target }) => {
        //console.log(target.name);
        if (target.name === 'number') {
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === 'expiry') {
            target.value = formatExpirationDate(target.value);
        } else if (target.name === 'cvc') {
            target.value = formatCVC(target.value);
        }

        this.setState({ cardData: {...this.state.cardData, [target.name]: target.value} });

        //console.log(this.state.cardData);
    };

    handleInputFocus = ({ target }) => {
        this.setState({
            focused: target.name,
        });
    };

    changeWindows = () => {
        this.setState({
            myWallet: !this.state.myWallet,
            addCardForm: !this.state.addCardForm,
            focused: '',
            cardData: {
                type: '',
                name: '',
                number: '',
                expiry: '',
                cvv: '',
                cpf: ''
            }
        });
    }

    componentDidMount() {
        this.AccountDetails();
        this.GetCard();
        let self_ = this;
        setTimeout(function(){
            self_.selectCard(0);
        },2000);
    }

    render() {
        
        if((JSON.parse(localStorage.getItem("clientInfo")) === null)||(this.state.redirect) ) {
            return <Redirect to={{
                pathname: "/"
            }}/>
        }

        return (
            <div className="home wallet">
                
                <Menu currBalance={this.state.currBalance} phone={this.state.phone}  />
               <div className="btn-voltar-wallet">
                <div className="btn-back"><Link to="/home">Voltar </Link></div>
               </div>
               {(this.state.myWallet&&(this.state.cardList.length !== 0)) &&
                    <div className="container--wallet">
                            <div className="container--wallet-center">
                                <div className="container--wallet-cards">
                                    <div className="container--wallet-cards-header">
                                        <div>Minha Carteira</div>
                                    </div>
                                    <ul className="wallet--list-cards">
                                        {this.state.cardList.map((item, i) => 
                                        <li key={i} onClick={() => this.selectCard((i === this.state.cardSelected.index)? "n":i)} className={(i === this.state.cardSelected.index)? "active":""}>
                                            <Cards
                                                number={item.bin.substring(0, 4) + "00000000" + item.digFour}
                                                name={item.name}
                                                expiry={item.expiration.substring(0, 2) + "/" + item.expiration.substring(2, 4) }
                                            />
                                            <span className="start-card">**** **** **** {item.digFour}</span>
                                            {(i === this.state.cardSelected.index)&&
                                                <div className="card-config">
                                                    <a href="#" onClick={this.deleteCard}>Excluir</a>
                                                    {/* <span>|</span>
                                                    <a href="#">Alterar</a> */}
                                                </div>
                                            }
                                        </li>
                                        
                                        )}
                                            
                                    </ul>
                                </div>
                                
                                {(this.state.cardSelected.index !== "n")
                                    ? <div className="container-wallet-history">
                                        <h3>{this.state.cardSelected.flag} final {this.state.cardSelected.digFour}</h3>
                                        <div className="history-table">
                                            <ul className="list--history">
                                                <li className="list--history-header">
                                                    <span>Data</span>
                                                    <span>Canal</span>
                                                    <span>Método</span>
                                                    <span>Valor</span>
                                                </li>

                                                {((this.state.financial !== null)&&(this.state.financial.length !== 0))
                                                
                                                    ? <ul>
                                                        {this.state.financial.map((item,i) => 
                                                            <li className="list--history-data">
                                                                <span>
                                                                    {item.transDate.split(" ")[1]}<br/>
                                                                    {this.formartDate(item.transDate.split(" ")[0])}
                                                                </span>
                                                                <span>
                                                                    <i className={`icon-${item.source}`}></i>
                                                                    <p>{item.source}</p>
                                                                </span>
                                                                <span>
                                                                    <i className="icon-Cartao"></i>
                                                                    <p>Cartão</p>
                                                                    </span>
                                                                <span>R$ {item.amount}</span>
                                                            </li>
                                                        )}


                                                        
                                                    
                                                    
                                                    </ul>
                                                    : <span className="semRegistros">Você não possui históricos desse mês</span>
                                                
                                                }


                                            </ul>
                                            <div className="value-total">Total: <span>R$ {this.state.total}</span></div>
                                        </div>
                                    </div>
                                    : <div className="cardNoSelected">
                                        <p>Por favor, selecione um cartão.</p>
                                    </div>
                                }   
                            </div>
                    
                            <div className="containerNewCard">
                                <div onClick={this.changeWindows} className="btn btn-newcard">Adicionar Cartão</div>
                            </div>
                    </div>      
                }

                {(this.state.myWallet&&(this.state.cardList.length === 0)) &&
                    <div className="container--wallet">
                        <div className="container--wallet-center">
                            <div className="container--wallet-cards">
                                <div className="container--wallet-cards-header">
                                    <div>Minha Carteira</div>
                                </div>
                                <ul className="wallet--list-cards">
                                    
                                        
                                </ul>
                            </div>
                            
                            <div className="no-have-card">
                                <img src={walletEmpy} />
                                <p>Ooops, parece que você não tem <br/> nenhum cartão adicionado</p>
                                <div className="containerNewCard">
                                    <div onClick={this.changeWindows} className="btn btn-newcard">Adicionar Cartão</div>
                                </div>
                            </div>
                                
                        </div>
                    </div>      
                }
                

                {this.state.addCardForm && 
                    <div className="display-add-card card-container addCardWallet">

                        <h2>Novo Cartão de crédito</h2>
                        <div className="card-content">
                            <div className="content-payment-body-info">    
                                    <form>
                                        <label>Número do cartão</label>
                                        <NumberFormat 
                                            type="text"
                                            name="number"
                                            placeholder="5555 **** **** 7181"
                                            required
                                            onValueChange={(values) => {
                                                const {value} = values;
                                                this.setState({cardData: {...this.state.cardData, number: value}});
                                            }} 
                                            onFocus={this.handleInputFocus}
                                            format="####.####.####.####"
                                        />

                                        <label>Nome titular</label>
                                        <input 
                                            type="text"
                                            name="name"
                                            placeholder="José da Silva"
                                            required
                                            onChange={this.handleInputChange}
                                            onFocus={this.handleInputFocus}/>

                                        <div className="both-info">
                                            <div>

                                                <label>Data de vencimento</label>
                                                <NumberFormat 
                                                    type="text"
                                                    name="expiry"
                                                    placeholder="04/21"
                                                    pattern="\d\d/\d\d"
                                                    required
                                                    onValueChange={(values) => {
                                                        const {value} = values;
                                                        this.setState({cardData: {...this.state.cardData, expiry: value}});
                                                    }} 
                                                    onFocus={this.handleInputFocus}
                                                    format="##/##" 
                                                />

                                            </div>
                                            <div>

                                                <label>CVV</label>
                                                {/* <input 
                                                    type="text"
                                                    name="cvc" 
                                                    placeholder="***"
                                                    pattern="\d{3,4}"
                                                    required
                                                    onChange={this.handleInputChange}
                                                    onFocus={this.handleInputFocus}/> */}
                                                    <NumberFormat 
                                                        type="text"
                                                        name="cvc" 
                                                        value={this.state.cardData.cvv} 
                                                        placeholder="***"
                                                        onValueChange={(values) => {
                                                            const {value} = values;
                                                            this.setState({cardData: {...this.state.cardData, cvv: value} });
                                                            // console.log(this.state.cardData);
                                                        }}  
                                                        onFocus={this.handleInputFocus}
                                                        format="####" 
                                                    />

                                            </div>
                                        </div>

                                        <label>CPF</label>
                                        <NumberFormat 
                                            value={this.state.cardData.cpf} 
                                            placeholder="123.456.789-10"
                                            onValueChange={(values) => {
                                                const {value} = values;
                                                if(value.length === 11 && !this.validCpf(value)){
                                                    Swal.fire({
                                                        title: 'Erro!',
                                                        text: "CPF inválido!",
                                                        type: 'error',
                                                        icon: 'error'
                                                    })
                                                    //this.setState({loading: 0}); 
                                                }
                                                this.setState({cardData: {...this.state.cardData, cpf: value} });
                                                // console.log(this.state.cardData);
                                            }}  
                                            format="###.###.###-##" 
                                        />

                                    </form>
                            </div>
                        
                            <div className="content-payment-body-card">
                            <Cards
                                number={this.state.cardData.number}
                                name={this.state.cardData.name}
                                expiry={this.state.cardData.expiry}
                                cvc={this.state.cardData.cvv}
                                focused={this.state.focused}
                                callback={this.handleCallback}
                            />
                        </div>
                        </div>
                        
                        <div className="container-btn-add">
                            <button className="btn btn-cancel" onClick={this.changeWindows}>cancelar</button>
                            <button className="btn btn-success" onClick={this.addCreditcard}>Salvar</button>
                    
                        </div>
                    </div>
                }

                

                <Loading loading={this.state.loading} />        
            </div>
        );
    }
}

export default Wallet;
